// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"c0dff9a6","479":"52da8838","480":"c0dff9a6","490":"c0dff9a6","834":"c0dff9a6"}[chunkId] + ".chunk.css";
};